export const howMuchMoneyData = {
  title: 'Approximately how much money was taken?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/6ed60b91eef8-tooliconcalculator.jpg',
  },
  id: 'how-much-money',
  options: [
    {
      label: 'Pound Sterling (GBP)',
      value: 'gbp',
    },
    {
      label: 'US Dollar (USD)',
      value: 'usd',
    },
    {
      label: 'Euro (EUR)',
      value: 'eur',
    },
    {
      label: 'Japanese Yen (JPY)',
      value: 'jpy',
    },
    {
      label: 'Australian Dollar (AUD)',
      value: 'aud',
    },
    {
      label: 'Canadian Dollar (CAD)',
      value: 'cad',
    },
    {
      label: 'Swiss Frank (CHF)',
      value: 'chf',
    },
    {
      label: 'Chinese Renminbi (CNH)',
      value: 'cnh',
    },
    {
      label: 'Hong Kong Dollar (HKD)',
      value: 'hkd',
    },
    {
      label: 'New Zealand Dollar (NZD)',
      value: 'nzd',
    },
    {
      label: 'Other',
      value: 'other',
    },
  ],
}
